import { render, staticRenderFns } from "./AtomInputFileImagePrimary.vue?vue&type=template&id=66756576"
import script from "./AtomInputFileImagePrimary.vue?vue&type=script&lang=js"
export * from "./AtomInputFileImagePrimary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports